import axios from "axios";
import { MERCHANT_CODE, tenantPath } from "@/lib/tenant";
import { concernsCurrentSession } from "./authTransport";
import { backendBaseUrl } from "./backendUrl";
import { installRequestLoader } from "./requestLoader";
import { installBackgroundJobs } from "../features/jobs/transport";

const BACKEND_URL = backendBaseUrl();
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bd_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (MERCHANT_CODE) config.headers["X-Merchant-Code"] = MERCHANT_CODE;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    if (err.config?.accessRefresh) return Promise.reject(err);
    const code = err.response?.data?.detail?.code || err.response?.data?.code;
    if (status === 403 && code === "TENANT_MISMATCH" && concernsCurrentSession(err, "bd_token")) {
      localStorage.removeItem("bd_token");
      if (!window.location.pathname.endsWith("/login")) window.location.href = tenantPath("/login");
      return Promise.reject(err);
    }
    if (status === 401 && concernsCurrentSession(err, "bd_token") && !window.location.pathname.includes("/login")) {
      localStorage.removeItem("bd_token");
      window.location.href = tenantPath("/login");
    }
    return Promise.reject(err);
  }
);

export function apiError(err, fallback = "Something went wrong") {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof detail?.message === "string" && detail.message.trim()) return detail.message;
  if (typeof detail?.msg === "string" && detail.msg.trim()) return detail.msg;
  return fallback;
}

installBackgroundJobs(api);
installRequestLoader(api);
export default api;
